import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { HelpTypes } from '@pharmaplan/common';

import styles from './styles';

interface IProfessionalMapMarkers {
  type: HelpTypes;
  handleClick: () => void;
  name: string;
}

const ReplacementLabelsStyled = {
  [HelpTypes.pharmacist]: {
    backgroundColor: '#7D7CFD',
    color: 'white',
  },
  [HelpTypes.technicians]: {
    backgroundColor: '#27B1B4',
    color: 'white',
  },
  [HelpTypes.students]: {
    backgroundColor: '#EB8276',
    color: 'white',
  },
};

const ProfessionalMapMarkers: FC<IProfessionalMapMarkers> = ({
  name,
  type,
  handleClick,
}) => {
  const { backgroundColor } = ReplacementLabelsStyled[(type as keyof typeof ReplacementLabelsStyled) ?? HelpTypes.pharmacist] ?? {};
  const [first, last] = name?.split(' ') ?? [];

  const initials = `${first?.[0]?.toUpperCase()}${last?.[0]?.toUpperCase() ?? ''}`;

  return (
    <Box sx={[styles.marker, { backgroundColor }]} onClick={handleClick}>
      <Typography sx={styles.markerText}>{initials}</Typography>
    </Box>
  );
};

export default ProfessionalMapMarkers;
